import { constantsHubIcon } from "../utils/constants";

function Navbar({ isMenuOpen, setIsMenuOpen }) {

  return (
    <header className="relative w-full py-2">
      <div className="flex items-center justify-between">
        <div className="block laptop:hidden">
          <button
            className="w-[24px] h-[18px] *:h-full *:w-full cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {constantsHubIcon.menuIcon}
          </button>
          <button
            className="w-[180px]  ml-[14px] *:h-full *:w-full cursor-pointer relative top-0.5"
          >
            <img
              src={`${process.env.REACT_APP_S3_ASSETS_URL}vanar-hub.svg`}
              alt="Vanar Hub"
              className="max-w-[220px] max-h-full"
            />
          </button>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
